import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { NavigationService } from '@app/common-codes/services/navigation.service';

/**
 * Page d'erreur du kiosque : affichée à l'intérieur du périmètre /ipad
 * (compte Visitor confiné, erreur de configuration, route inconnue...).
 */
@Component({
    selector: 'app-ipad-error',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslatePipe],
    templateUrl: './ipad-error.component.html',
})
export class IpadErrorComponent {
    private navService = inject(NavigationService);

    goHome(): void {
        this.navService.navigateTo('/ipad/home');
    }
}
